<template>
    <footer class="footer">
        <div class="d-sm-flex justify-content-center justify-content-sm-between">
            <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">
                Copyright © {{ currentYear }} <a href="https://www.aform.lu" class="text-primary" target="_blank">Aform.lu</a>
                &nbsp; &middot; &nbsp;
                All rights reserved
                &nbsp; &middot; &nbsp;
                <router-link tag="a" :to="{name: 'terms-and-conditions'}" class="text-muted" target="_blank">
                        {{ $t('pages.login.t_and_c') }}
                </router-link>
            </span>

            <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">
                Hand-crafted & made with <i class="mdi mdi-heart text-danger"></i> by <a href="https://www.apps.lu" class="text-primary" target="_blank">Apps.lu</a>
            </span>
        </div>
    </footer>
</template>

<script>
export default {
    name: "DashboardFooter",
    computed: {
        currentYear() {
            return new Date().getFullYear();
        }
    }
}
</script>

<style scoped>

</style>
